<template>
    <section class="content">
        <app-menu v-if="isLoggedIn"></app-menu>
        <div class="container-fluid">
            <div class="block-header">
                <h2>Dashboard</h2>
            </div>
        </div>
    </section>
</template>
<script>
    import Vue from 'vue';
    import FrontMenu from '@/components/partials/FrontMenu';
    import SessioMixin from '../mixins/sessionmixin';
    Vue.component('app-menu', FrontMenu);
    export default {
        name: 'FrontHome',
        mixins: [SessioMixin],
        data: () => ({
                isLoggedIn: false,
                ssoUrl: '',
                projectSlug: '',
                token: '',
                username: '',
            }),
        mounted: function () {
            // this.$router.push("/login");
            // if (localStorage.getItem("menu_small") == '1') {
            //     this.menuSmall();
            // } else {
            //     this.menuBig();
            // }
            //Textare auto growth
            //autosize($('textarea.auto-growth'));


        },
        beforeMount: function () {
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('token')) {
                this.token = urlParams.get('token');
                this.username = urlParams.get('username');

                this.getUserObj();
            }else{
                var api_token = localStorage.getItem("api_token");
                if(api_token == null) {
                    this.ssoUrl = process.env.VUE_APP_SSO_ROOT_URL;
                    this.projectSlug = process.env.VUE_APP_PROJECT_SLUG;
                    const redirectUrl = window.location.href;
                    
                    window.location.href = `${this.ssoUrl}/login?redirect=${encodeURIComponent(redirectUrl)}&slug=${this.projectSlug}`;
                }else{
                    this.$router.push("/listcustomer");
                }
                
            }
        },
        methods: {
            getUserObj() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/autologinuser",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Authorization": "Bearer " + self.token,
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        username: self.username,
                    },
                    dataType: 'json',
                    success: function (data) {
                        window.localStorage.setItem("api_token", self.token);
                        window.localStorage.setItem("user_obj", JSON.stringify(data.content.user));
                        window.localStorage.setItem("menu_small", '1');
                        window.localStorage.setItem("app_year", data.app_year);

                        EventBus.$emit('logged-in', false, data.content.user["first_name"], data.content.user["last_name"], data.content.user["email"]);

                        self.$router.push("/listcustomer");
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else if (jqXHR.status == 401) {
                            // Clear previous data
                            localStorage.removeItem('user_obj');
                            localStorage.removeItem('api_token');
                            // Redirect to "/login" if user not authenticated
                            self.$router.push("/login");
                        }
                    }
                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/FrontHome.vue